<template>
  <div class="wrap">
    <p class="empty">没有相关自提点！</p>
  </div>
</template>

<script>
export default {
  created() {},
  mounted() {},
  data() {
    return {}
  },
  methods: {},
  props: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.empty {
  background: url('~assets/images/order/icon_null_address.png') no-repeat center
    top;
  background-size: rem(158px) rem(158px);
  font-size: rem(30px);
  color: #666;
  text-align: center;
  padding-top: rem(200px);
}
</style>
